import { Link, navigate } from "@reach/router"
// Styles
import { Breadcrumb_s, ChartChildTable_s } from "components/asset-management/chart/chart-styles"
import Controls from "components/asset-management/chart/controls/"
import { Errors } from "components/asset-management/errors"
// Components
import CarouselAutomation from "components/carousel-automation"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import ImportIcon from "components/import-export/import-icon"
import { Toolbar } from "components/subnav"
import { DetailedRouteUpDown_s, DetailedUpDownBtn_s } from "components/table/data-table-styles"
import { DropdownField } from "components/table/display"
import { DropdownEdit, MultiselectEdit, TextEdit } from "components/table/inputs"
import { field as _field } from "components/table/lib/column-field"
import SearchHeader from "components/table/search-header"
import {
  focusCellByContent, focusFirstCellByRowIndex, getFocusedRowIndex, getPagingInfo, pageToFirst, TableAutomation, unfocusAllCells
} from "components/table/table-automation"
import { WithTip } from 'components/tooltip/with-tip'
import { HeaderIcon_s } from "components/wrapper/header/header-styles"
// Data
import automationService from "data/automation"
import chartService, { Chart } from "data/chart"
import importService from "data/import"
import keyService, * as chord from "data/key"
import { canPaste, copy, getPasteInfo, paste } from "data/lib/copy-paste"
import { handleReferences } from "data/lib/handle-references"
import summaryAccountService from "data/summaryaccount"
import validationService from "data/validate"
import toggles from "feature-toggles"
import { BackArrowIcon, CaretRightIcon } from 'images/icons/general/'
import { AddIcon } from "images/icons/tools"
// Icons
import { CaretDownIcon, CaretUpIcon } from "images/icons/tools/"
import _ from "lodash"
import { Column } from "primereact/column"
import { ContextMenu } from "primereact/contextmenu"
// PR
import { DataTable } from "primereact/datatable"
import React, { useEffect, useRef, useState } from "react"
import Isvg from 'react-inlinesvg'
import { InputText_s } from "styles/input-styles"

type PropTypes = {
  path: string // from route
  chartId?: string // from route
}

type ContextRow = {
  summaryaccountid: number
  accountnumber: string
  sortorder?: number
  systeminput?: string
}

const tableId = "summaryAccountsTable"

const SummaryAccounts = (props: PropTypes) => {
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);
  const chartId = parseInt(props.chartId!)

  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const nonSystemMenu = [
    {label: 'Copy Cell', icon: 'pi pi-fw pi-copy', command: e => { if(contextRow.systeminput === "systemImmutable") return;
      copy(contextCell, contextRow)
    }},
    {label: selected.length ? 'Delete Rows' : 'Delete Row', icon: 'pi pi-fw pi-trash', command: e => { if(contextRow.systeminput) return;
      const pager         = getPagingInfo(tableId);
      const currentRowNum = getFocusedRowIndex() + 1
      const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
      showDeleteConfirmation(contextRow, currentRecordIndex + 1)
    }},{
      label: 'Trace', icon: 'pi pi-fw pi-search', command: e => {
        const refreshFn = () => summaryAccountService.fetchSummaryAccounts(chartId)
        handleReferences('summaryaccount', contextRow.summaryaccountid, {refreshFn});
    }}
  ]

  const [charts, setCharts] = useState<Chart[]|null>(null);
  const [currentChart, setCurrentChart] = useState<Chart|null>(null);
  const [summaries, setSummaries] = useState<object[]|null>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [searchFilter, setSearchFilter] = useState<string>("")
  const [contextRow, setContextRow] = useState<ContextRow>({summaryaccountid: 0, accountnumber: ''})
  const [contextCell, setContextCell] = useState<object|null>(null)
  const [deleteConfirmation, setDeleteConfirmation] = useState<JSX.Element | null>(null)
  const prevSearch = usePrevious(searchFilter);
  const [automationActive, setAutomationActive] = useState<boolean>(false);
  const [tableAutomationActive, setTableAutomationActive] = useState<boolean>(true);
  const [accountnumberFilter, setAccountnumberFilter] = useState<string>("");
  const [descriptionFilter, setDescriptionFilter] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("All");
  const [accountcategoryFilter, setAccountcategoryFilter] = useState<string>("All");
  const [propertytypeFilter, setpropertytypeFilter] = useState<string>("All");
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [menu, setMenu] = useState<[]|object[]>(nonSystemMenu)
  const [_errors, setErrors] = useState<any>()
  const menuRef = useRef<ContextMenu | null>(null)
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('summaryaccount')
  const statusOptions = [{value: 'Active', label: 'Active'},{value: 'Inactive', label: 'Inactive'}]
  const accountCategoryOptions = [{value: 'Revenue', label: 'Revenue'},{value: 'Operating Expenses', label: 'Operating Expenses'},{value: 'Capital Expenses', label: 'Capital Expenses'}]
  const propertyTypeOptions = [
    {value: 'Commercial', label: 'Commercial'},
    {value: 'Hospitality', label: 'Hospitality'},
    {value: 'Multifamily', label: 'Multifamily'}
  ]
  // these two could be factored out since detail-account doesn't have contain/table component split, but keeping the multiselect changes the same between files for now.
  const [deleteFlag, setDeleteFlag] = useState(0)
  const [pasteFlag, setPasteFlag] = useState(0)

  const chartid = currentChart?.chartid
  useEffect(() => {
    if(!chartid) return
    validationService.validateByParent('summaryaccount', 'chart', chartid)
  },[chartid])

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  useEffect(() => {
    setTableAutomationActive(true)
    setAutomationActive(false)
  }, [currentChart])

  useEffect(() => {
    setMenu(nonSystemMenu)
  }, [contextRow])

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_PLUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            unfocusAllCells()
            summaryAccountService.create(chartId)
          }
          break
        case k.chord === chord.CTRL_SHIFT_MINUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            const pager         = getPagingInfo(tableId);
            const currentRowNum = getFocusedRowIndex() + 1
            const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
            const records       = tableRef.current.props.value!;
            const currentRow    = records[currentRecordIndex];
            if (!currentRow.systeminput) showDeleteConfirmation(currentRow, currentRecordIndex + 1)
          }
          break
        case k.chord === chord.CTRL_SHIFT_UP && k.down === true:
          toggleChart('up')
          break
        case k.chord === chord.CTRL_SHIFT_DOWN && k.down === true:
          toggleChart('down')
          break
        case k.chord === chord.CTRL_SHIFT_BACK && k.down === true:
          navigate('/n/asset-management/chart')
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  })

  useEffect(() => {
    const chartSubscription = chartService.stream().subscribe((data) => {
      if (data.state === "ok"){
        setCharts(data.value)
        setCurrentChart(_.find(data.value, {chartid: chartId}))
      }
    })

    const summaryAccountSubscription = summaryAccountService.stream().subscribe((data) => {
      if (data.state === "ok"){
        // map summary propertytype array to dropdown friendly version
        const s = _.map(_.cloneDeep(data.value), (val, idx) => {
          if(_.isArray(val.propertytype)) {
            val.propertytype = `{${_.join(val.propertytype,',')}}`
          }
          return val
        })
        setSummaries(s)
      }
    })

    const summaryAccountEventSubscription = summaryAccountService.eventStream().subscribe(e => {
      switch(true) {
        case e.type === "SUMMARYACCOUNT_CREATED":
          setTimeout(() => pageToFirst(tableId), 1)
          setTimeout(() => {
            focusFirstCellByRowIndex(tableId, 0)
          }, 500)
          break
        case e.type === "SUMMARYACCOUNT_COPIED":
          setTimeout(() => {
            focusCellByContent(tableId, e.payload.code)
          }, 500)
      }
    })

    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    const validationSubscription = validationService.stream().subscribe((e) => {
      setErrors(e)
    })

    chartService.fetchCharts()
    summaryAccountService.fetchSummaryAccounts(chartId)

    return function cleanup() {
      chartSubscription.unsubscribe()
      summaryAccountSubscription.unsubscribe()
      summaryAccountEventSubscription.unsubscribe()
      validationSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    const filter = (errors) => {
      if (!currentChart) return errors
      const chartid = _.get(currentChart, 'chartid')
      if (!chartid) return errors
      let { chart, cashflowmap, detailaccount, summaryaccount } = _.cloneDeep(_.pick(errors.errordetail, 'chart', 'summaryaccount', 'cashflowmap', 'detailaccount'))

      if (chart) chart = {[chartid]: chart[chartid] || []}

      for (let table of [cashflowmap, detailaccount, summaryaccount]) {
        for (let id in (table||{})){
          if (table[id][0]['_object'].chartid !== chartid) {
            delete table[id]
          }
        }
      }

      return {
        ...errors,
        errordetail: {chart, cashflowmap, detailaccount, summaryaccount},
        calcDetail: undefined
      }
    }
    validationService.addFilter(filter)
    return () => validationService.removeFilter(filter)
  }, [currentChart])

  useEffect(() => {
    filterData();
  }, [summaries, accountnumberFilter, descriptionFilter, statusFilter, accountcategoryFilter, propertytypeFilter])

  const persist = (value, field, rowData) => {
    const summaryAccount = _.cloneDeep(rowData)
    if (field === 'propertytype') value = value.length > 0 ? `{${value.sort().toString()}}` : null
    _.set(summaryAccount, field, value)
    summaryAccountService.patch(summaryAccount)
  }

  const refresh = async () => {
    const summaryaccounts = await summaryAccountService.fetchSummaryAccounts(chartId)
    setSelected(_.intersectionBy(summaryaccounts, selected, 'summaryaccountid'))
  }

  useEffect(() => {
    if(canPaste(contextCell, selected)) {
      nonSystemMenu.splice(1, 0, {label: selected.length ? 'Paste to Rows' : 'Paste Cell', icon: 'pi pi-fw pi-file', command: e => {
        if (selected.length > 1) {
          showPasteConfirmation(contextRow, -1)
          return
        }
        paste(contextCell, contextRow, refresh, 'summaryaccount', selected)
      }})
    }
    contextRow.systeminput === "systemImmutable" ? setMenu([]) : setMenu(nonSystemMenu)
  }, [contextCell, selected.length])

  useEffect(() => {
    if (!deleteFlag) return //skip first time
    showDeleteConfirmation(_.first(selected), -1)
  }, [deleteFlag])

  function showDeleteConfirmation(record: ContextRow, currentRow: number) {
    automationService.broadcast("MODAL_OPENING", {})
    setDeleteConfirmation(Controls.ChartChildDeleteConfirmation({
      show: true,
      message: `Would you like to delete the ${selected.length} selected rows? Note this cannot be undone.`,
      close: () => {
        setDeleteConfirmation(null)
        setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
      },
      confirm: () => {
        if (selected.length > 1) {
          summaryAccountService.deleteMultiple(chartId, _.map(selected, 'summaryaccountid'))
        } else {
          summaryAccountService.deleteOne(chartId, record.summaryaccountid)
        }
        // summaryAccountService.deleteOne(chartId, record.summaryaccountid)
        setDeleteConfirmation(null)
        setTimeout(() => {
          focusFirstCellByRowIndex(tableId, currentRow - 2 > 0 ? currentRow - 2 : 0)
        }, 200)
      },
      rowNum: currentRow,
      accountnumber: record.accountnumber,
      selected
    }))
  }

  useEffect(() => {
    if (!pasteFlag) return //skip first time
    if (!canPaste(contextCell, selected)) return
    showPasteConfirmation(contextRow, -1)
  }, [pasteFlag])

  const showPasteConfirmation = (record: ContextRow, currentRow: number) => {
    automationService.broadcast("MODAL_OPENING", {})
    setDeleteConfirmation(Controls.ChartChildDeleteConfirmation({
      show: true,
      title: 'Paste',
      message: `Would you like to paste ${getPasteInfo()._meta.field} data to the ${selected.length} selected rows? Note this cannot be undone.`,
      close: () => {
        setDeleteConfirmation(null)
        setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
      },
      confirm: () => {
        paste(contextCell, contextRow, refresh, 'summaryaccount', selected)
        setDeleteConfirmation(null)
        setTimeout(() => {
          focusFirstCellByRowIndex(tableId, currentRow - 2 > 0 ? currentRow - 2 : 0)
        }, 200)
      },
      rowNum: currentRow,
      accountnumber: record.accountnumber,
      selected
    }))
  }

  function updateContextMenu(originalEvent){
    if (!menu.length){
      setMenu(nonSystemMenu)
    }
    _.invoke(menuRef.current, "show", originalEvent)
  }

  function filterData():void {
    let nextData = _.cloneDeep(summaries);

    if (accountnumberFilter !== "") nextData = nextData.filter(item => _.get(item, 'accountnumber')?.toLowerCase().includes(accountnumberFilter.toLowerCase()))
    if (descriptionFilter !== "") nextData = nextData.filter(item => _.get(item, 'description')?.toLowerCase().includes(descriptionFilter.toLowerCase()))
    if (statusFilter !== "All") nextData = nextData.filter(item => _.get(item, 'status') && _.find(statusOptions, { value: _.get(item, 'status')})['label'].toLowerCase().includes(statusFilter.toLowerCase()))
    if (accountcategoryFilter !== "All") nextData = nextData.filter(item => _.get(item, 'accountcategory') && _.find(accountCategoryOptions, { value: _.get(item, 'accountcategory')})['label'].toLowerCase().includes(accountcategoryFilter.toLowerCase()))
    if (propertytypeFilter !== "All") nextData = nextData.filter(item => _.get(item, 'propertytype')?.toLowerCase().includes(propertytypeFilter.toLowerCase()))

    setFilteredData(nextData)
  }

  function toggleChart(direction:string):void {
    const currentChartIdx       = charts?.indexOf(currentChart!);
    let   nextChart:Chart|null  = null
    if (direction === 'up' && charts){
      nextChart = charts && charts[currentChartIdx! - 1]
    } else {
      nextChart = charts && charts[currentChartIdx! + 1]
    }
    if (nextChart) setCurrentChart(nextChart)
    nextChart && summaryAccountService.fetchSummaryAccounts(nextChart['chartid'])
  }

  const rowClassName = (rowData) => {
    return {'' : rowData}
  }

  const Add = () => {
    return (
      <a onClick={() => summaryAccountService.create(chartId)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(filteredData, selected, 'summaryaccountid'))
  }, [filteredData])

  const _data = showSelected ? selected : filteredData

  let finalData = _data.map(e => {
    if (showSelected) debugger
    return { ...e, 'propertytype': e.propertytype?.replace('{', '').replace('}', '').split(',')}
  })

  return (
    <div>
      <Toolbar>
        <Add />&nbsp;&nbsp;
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        <ImportIcon info={{chartid: _.get(currentChart, 'chartid')}} />
        {currentChart && <ExportIcon template="summaryaccount" chartid={_.get(currentChart, 'chartid')} /> }
        {currentChart &&
          <Breadcrumb_s>
            <Link to="/n/asset-management/chart">
              <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={BackArrowIcon} /></HeaderIcon_s>
              Chart
            </Link>
            <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={CaretRightIcon} /></HeaderIcon_s>
            <div>Summary Accounts</div>
            <DetailedRouteUpDown_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordUp" disabled={!charts || _.isNil(charts[charts.indexOf(currentChart!) - 1])} onClick={()=>toggleChart('up')}><Isvg src={CaretUpIcon} /></DetailedUpDownBtn_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordDown" disabled={!charts || _.isNil(charts[charts.indexOf(currentChart!) + 1])} onClick={()=>toggleChart('down')}><Isvg src={CaretDownIcon} /></DetailedUpDownBtn_s>
            </DetailedRouteUpDown_s>
            <div>{_.get(currentChart, "code")}</div>
          </Breadcrumb_s>
        }
        <Errors />
      </Toolbar>
      <SearchHeader setSearchFilter={setSearchFilter} />
      <ContextMenu model={menu} ref={menuRef} appendTo={document.querySelector("body")} onHide={() => {}}/>
      { showImport ? <Import /> :
      <ChartChildTable_s id="summary-accounts-table-scrollable-container">
        <DataTable
          globalFilter={searchFilter}
          id={tableId}
          ref={tableRef}
          value={finalData}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          frozenWidth={toggles.multiselect() ? "45px" : void 0}
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          onContextMenu={e => menuRef.current ? updateContextMenu(e.originalEvent) : null}
          contextMenuSelection={contextRow}
          onContextMenuSelectionChange={e => {
            setSelected([])
            setContextRow(e.value)
            setContextCell(e.originalEvent.target)
          }}
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
          selection={selected} onSelectionChange={(e) => {
            const selected = _.filter(e.value, (it) => it.systeminput !== "systemImmutable")
            setSelected(selected)
          }}
        >
          {toggles.multiselect() && <Column selectionMode="multiple" frozen={true} style={{minWidth: "45px", paddingLeft: "8px"}}/>}
          <Column style={{minWidth: "200px"}} className="p-editable-column"
            filter
            sortable
            header="Summary Account#"
            {...field('accountnumber')}
            editor={props => TextEdit({persist, ...props})}
            filterElement={
              <InputText_s value={accountnumberFilter} onChange={(e) => setAccountnumberFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "325px"}} className="p-editable-column"
            filter
            sortable
            header="Description"
            {...field('description')}
            editor={props => TextEdit({persist, ...props})}
            filterElement={
              <InputText_s value={descriptionFilter} onChange={(e) => setDescriptionFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "100px"}} className="p-editable-column"
            filter
            sortable
            header="Status"
            {...field('status', (rowData, props) => DropdownField({options: statusOptions, rowData, ...props}))}
            editor={props => <DropdownEdit options={statusOptions} default="" persist={persist} {...props} />}
            filterElement={
              <DropdownEdit
                field="statusFilter"
                rowData={{statusFilter}}
                options={[{value:"All", label:"All"}, ...statusOptions]}
                persist={(val) => setStatusFilter(val)}
              />
            }
          />
          <Column style={{minWidth: "275px"}} className="p-editable-column"
            filter
            sortable
            header="Account Category"
            {...field('accountcategory', (rowData, props) => DropdownField({options: accountCategoryOptions, rowData, ...props}))}
            editor={props => <DropdownEdit options={accountCategoryOptions} default="" persist={persist} {...props} />}
            filterElement={
              <DropdownEdit
                field="accountcategoryFilter"
                rowData={{accountcategoryFilter}}
                options={[{value:"All", label:"All"}, ...accountCategoryOptions]}
                persist={(val) => setAccountcategoryFilter(val)}
              />
            }
          />
          <Column style={{minWidth: "275px"}} className="p-editable-column"
            filter
            sortable
            header="Property Type"
            {...field('propertytype', (rowData) => rowData['propertytype']?.join(", "))}
            editor={props => MultiselectEdit({options: propertyTypeOptions, persist, ...props})}
            filterElement={
              <DropdownEdit
                field="propertytypeFilter"
                rowData={{propertytypeFilter}}
                options={[{value:"All", label:"All"}, ...propertyTypeOptions]}
                persist={(val) => setpropertytypeFilter(val)}
              />
            }
          />
        </DataTable>
        { deleteConfirmation }
        { filteredData && filteredData.length
          ? <div>
              <CarouselAutomation outsideTable={true} automationActive={!tableAutomationActive} editableFilters={true} includeSearchBar={true} tabOut={() => { setAutomationActive(false); setTableAutomationActive(true) }}/>
              <TableAutomation tableId={tableId} automationActive={tableAutomationActive} shiftTabOut={() => setTableAutomationActive(false)}/>
            </div>
          : null
        }
        <span className="selection-count">{ selected.length ? `Selected Rows: ${selected.length}`: null}</span>
      </ChartChildTable_s>}
    </div>
  )
}

export default SummaryAccounts
